let uid = null;

export default class Session {
  static uid(_uid) {
    if (typeof _uid === "string" && _uid !== "") {
      uid = _uid;
    }
    return uid;
  }
}
